// extracted by mini-css-extract-plugin
export var background = "_6s-0";
export var container = "_6s-1";
export var contentItem = "_6s-7";
export var extendedWarranty = "_6s-5";
export var link = "_6s-d";
export var modal = "_6s-b";
export var modalCloseButton = "_6s-9";
export var modalContent = "_6s-3";
export var modalContentMain = "_6s-6";
export var modalImageLogo = "_6s-8";
export var modalLogo = "_6s-a";
export var modalSideImage = "_6s-4";
export var preview = "_6s-c";
export var redoModal = "_6s-2";